import React, { useState, useEffect } from "react";
import axios from "axios";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  Button,
  Typography,
  Switch,
  FormControlLabel,
} from "@mui/material";
import { getToken, base_url } from "../../config/config";

const Comparision = () => {
  const [spalte1Values, setSpalte1Values] = useState([]);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterZero, setFilterZero] = useState(false); // State to control filtering
  const [totals, setTotals] = useState({
    totalEinzelpreis: 0,
    totalProfitLoss: 0,
    finaltotal: 0,
  });

  useEffect(() => {
    const fetchANRValues = async () => {
      try {
        const response = await axios.get(`${base_url}/v1/getBulkreport`);
        const anrData = response.data.data.map((item) => ({
          ANR: item.ANR,
          Einzelpreis: item.Einzelpreis,
        }));
        setSpalte1Values(anrData);
      } catch (error) {
        console.error("Error fetching ANR values:", error);
      }
    };

    fetchANRValues();
  }, []);

  const handleCalculate = async () => {
    if (spalte1Values.length === 0) {
      console.error("No ANR values to calculate");
      return;
    }

    setLoading(true);
    try {
      const anrValues = spalte1Values.map((item) => item.ANR);
      const response = await axios.post(
        "http://35.159.43.224:3080/m1/data/calculate",
        {
          spalte1Values: anrValues,
        },
      );
      const resultData = response.data.map((result) => {
        const matchedItem = spalte1Values.find(
          (item) => item.ANR === result.spalte1,
        );
        const einzelpreis = matchedItem ? matchedItem.Einzelpreis : 0;
        const totalCost = result.totalCost || 0;
        const totalAz = result.totalAz || 0;
        const profitLoss = einzelpreis - totalCost;

        return {
          ...result,
          Einzelpreis: einzelpreis,
          ProfitLoss: profitLoss,
          totalAz, // Ensure totalAz is included in the result
        };
      });

      setData(resultData);
      applyFilter(resultData); // Apply filter initially if needed
    } catch (error) {
      console.error("Error calculating data:", error);
    } finally {
      setLoading(false);
    }
  };

  const applyFilter = (data) => {
    var totalcost = data.reduce(function (accumulator, currentValue) {
      return accumulator + parseInt(currentValue.totalCost, 10);
    }, 0);

    console.log(totalcost);

    var totalprofit = data.reduce(function (accumulator, currentValue) {
      return accumulator + parseInt(currentValue.ProfitLoss, 10);
    }, 0);

    setTotals({
      totalEinzelpreis: totalcost,
      totalProfitLoss: totalprofit,
      finaltotal: totalcost - totalprofit,
    });

    const filtered = filterZero
      ? data.filter((item) => item.totalCost !== 0 || item.totalAz !== 0)
      : data;
    setFilteredData(filtered);
    // Calculate totals whenever filtered data changes
  };

  useEffect(() => {
    applyFilter(data); // Apply filter whenever filterZero changes
  }, [filterZero, data]);

  const formatNumber = (num) => {
    return typeof num === "number" ? num.toFixed(2) : "0.00";
  };

  const columns = [
    { accessorKey: "spalte1", header: "Spalte1" },
    { accessorKey: "totalAz", header: "Total Time (hours)" },
    { accessorKey: "totalCost", header: "Total Cost" },
    { accessorKey: "Einzelpreis", header: "Einzelpreis" },
    {
      accessorKey: "ProfitLoss",
      header: "Profit/Loss",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        const color = value < 0 ? "red" : "green";
        return (
          <Typography style={{ color }}>
            {value < 0
              ? `- $${Math.abs(value).toFixed(2)}`
              : `+ $${value.toFixed(2)}`}
          </Typography>
        );
      },
    },
  ];

  return (
    <Box sx={{ p: 2 }}>
      <Button variant='contained' onClick={handleCalculate} disabled={loading}>
        {loading ? "Calculating..." : "Calculate"}
      </Button>
      <Box sx={{ mt: 2, mb: 2 }}>
        <FormControlLabel
          control={
            <Switch
              checked={filterZero}
              onChange={(e) => setFilterZero(e.target.checked)}
              color='primary'
            />
          }
          label='Hide rows where Total Cost and Total Time are both 0'
        />
      </Box>
      <Box sx={{ mt: 2 }}>
        <MaterialReactTable columns={columns} data={filteredData} />
      </Box>
      <Box sx={{ mt: 2 }}>
        <Typography variant='h6'>Totals</Typography>
        <Typography>
          Total Einzelpreis: ${formatNumber(totals.totalEinzelpreis)}
        </Typography>
        <Typography>
          Total Profit/Loss: ${formatNumber(totals.totalProfitLoss)}
        </Typography>
        <Typography variant='h6'>
          Overall Profit/Loss:
          <span style={{ color: totals.finaltotal < 0 ? "red" : "green" }}>
            {totals.totalProfitLoss < 0
              ? `- $${Math.abs(totals.finaltotal).toFixed(2)}`
              : `+ $${totals.finaltotal.toFixed(2)}`}
          </span>
        </Typography>
      </Box>
    </Box>
  );
};

export default Comparision;
